<template>
  <div v-if="type == 2" class="preview-box">
    <div
      v-for="(img, index) in images"
      :key="index"
      :style="{ 'z-index': index >= imgLayer ? index + 1 : index }"
      style="position: absolute; inset: 0; width: 100%; height: 100%"
    >
      <img :src="img" alt="" />
    </div>
    <div
      :id="`three-${id}`"
      :style="{ 'z-index': imgLayer }"
      style="
        position: absolute;
        width: 600px;
        height: 600px;
        transform: scale(1);
        transform-origin: center center;
      "
    ></div>
  </div>
  <div
    v-else-if="type == 4"
    :style="{ width: width + 'px', height: height + 'px' }"
  >
    <canvas :id="`psdCanvas-${id}`" :style="psdStyle"></canvas>
  </div>
</template>
<script>
import renderModel from "@/utils/renderModel.js";
import SmartObjectRenderer from "@/utils/SmartObject.js";
import { delay } from "@/utils/util.ts";
export default {
  props: {
    value: {
      type: [Object],
    },
    images: {
      type: Array,
    },
    imgLayer: {
      type: Number,
    },
    modelParams: {
      type: Object,
      default: () => {},
    },
    materialList: {
      type: Object,
      default: () => {},
    },
    modelUrl: {
      type: Array,
    },
    id: {
      type: [String, Number],
    },
    width: {
      type: Number,
      default: 600,
    },
    height: {
      type: Number,
      default: 600,
    },
    type: {
      type: Number,
      default: 3,
    },
  },

  data() {
    return {
      modelApi: {},
      loading: true,
      threeLeft: 0,
      psdCanvas: null,
      imgObject: {},
      psdData: {},
      pathBoundsCache: new Map(), // 路径边界缓存
      bmList: {
        normal: "source-over",
        "pass through": "source-over",
        multiply: "multiply",
        "soft light": "soft-light",
        "linear burn": "color-burn",
      },
      psdSize: {
        scaleX: 1,
        scaleY: 1,
        left: 0,
        top: 0,
      },
      psdStyle: {},
    };
  },

  computed: {},

  methods: {
    async modelAction(func, params) {
      try {
        if (!this.modelApi || !this.modelApi[func]) return;
        let result = await this.modelApi[func](params);
        const img = await this.modelApi.toDataURL();
        this.$emit("setEffectImg", img);
        return result;
      } catch (error) {
        console.error(error);
      }
    },

    toDataURL() {
      return this.modelApi.toDataURL();
    },

    async setBatchMapTexture(params) {
      try {
        if (!this.modelApi.setMap) {
          return;
        }
        await this.modelApi.setMap(params);
      } catch (e) {
        throw e;
      }
    },

    async init() {
      this.modelApi = new renderModel("#three-" + this.id);
      const params = {
        modelParams: this.modelParams,
        materialList: this.materialList,
        targetSize: 2,
      };
      params.fileParams = Array.isArray(this.modelUrl)
        ? this.modelUrl
        : [this.modelUrl];
      if (!params.fileParams[0]["url"]) {
        this.loading = false;
        return;
      }
      await this.modelApi.init(params);
      await delay(200);
      const img = await this.modelApi.toDataURL();
      this.$emit("setEffectImg", img);
      this.loading = false;
    },

    async bactInit() {
      try {
        this.modelApi = new renderModel("#three-" + this.id);
        const params = {
          modelParams: this.modelParams,
          materialList: this.materialList,
          targetSize: 2,
        };
        params.fileParams = Array.isArray(this.modelUrl)
          ? this.modelUrl
          : [this.modelUrl];

        // 检查是否有有效的文件 URL，如果没有则结束初始化
        if (!params.fileParams[0]?.url) {
          this.loading = false;
          return true;
        }

        await delay(50);
        await this.modelApi.init(params);
        await delay(100);

        this.loading = false;
        return true;
      } catch (e) {
        // 捕获异常并抛出，让调用者处理
        throw e;
      }
    },

    async psdAction(func, params) {
      try {
        if (!this[func]) return;
        return await this[func](params);
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    buildPsdValue() {
      for (const layer of this.psdData.psdDatas) {
        if (layer.IMG) {
          this.imgObject[layer.N] = layer.IMG;
        } else if (layer.CL) {
          const SmartObject = layer.CL.find((c) => c.T == "SmartObject");
          if (SmartObject.IMG) {
            this.imgObject[layer.N] = SmartObject.IMG;
          }
        }
      }
    },

    async createTextureByFace({ texture, name }) {
      try {
        const layerData = this.psdData.psdDatas.find((item) => item.N === name);
        if (!layerData) {
          return;
        }
        const value = layerData.CL
          ? layerData.CL.find((i) => i.T == "SmartObject")
          : layerData;
        if (value.M) {
          const render = new SmartObjectRenderer({
            size: value.WT,
            bg_img: value.IMG,
          });
          const glCanvasImg = await render.setTexture({
            imageUrl: texture,
            meshPoints: value.PS,
            customMatrix: value.M,
            width: value.OS[0],
            height: value.OS[1],
          });
          this.imgObject[name] = glCanvasImg;
        } else {
          this.imgObject[name] = texture;
        }
        return this.imgObject[name];
      } catch (error) {
        console.log("🚀 ~ error:", error);
        throw error;
      }
    },

    async createTextureByFaceFactory({ texture, name }) {
      try {
        const layerData = this.psdData.psdDatas.find((item) => item.N === name);
        if (!layerData) {
          return;
        }
        const value = layerData.CL
          ? layerData.CL.find((i) => i.T == "SmartObject")
          : layerData;
        if (value.M) {
          const render = new SmartObjectRenderer({
            size: value.WT,
            bg_img: value.IMG,
          });
          const glCanvasImg = await render.setTexture({
            imageUrl: texture,
            meshPoints: value.PS,
            customMatrix: value.M,
            width: value.OS[0],
            height: value.OS[1],
          });
          // this.imgObject[name] = glCanvasImg
        } else {
          // this.imgObject[name] = texture
        }
        return { name: name, texture: texture };
      } catch (error) {
        console.log("🚀 ~ error:", error);
        throw error;
      }
    },

    async createTextureByFaceBatch({ layerData, texture, name }) {
      try {
        const value = layerData.CL
          ? layerData.CL.find((i) => i.T == "SmartObject")
          : layerData;
        let img = texture;
        if (value.M) {
          const render = new SmartObjectRenderer({
            size: value.WT,
            bg_img: value.IMG,
          });
          const glCanvasImg = await render.setTexture({
            imageUrl: texture,
            meshPoints: value.PS,
            customMatrix: value.M,
          });
          img = glCanvasImg;
        }
        this.imgObject[name] = img;
        return img;
      } catch (error) {
        console.log("🚀 ~ error:", error);
        throw error;
      }
    },

    async initPsdCavans() {
      try {
        const psdData = this.psdData;
        const maxSide = Math.max(psdData?.width, psdData?.height);
        const scale = this.width / maxSide;
        const scaleX = scale;
        const scaleY = scale;
        const left = (this.width - psdData?.width * scale) / 2;

        const top = (this.height - psdData?.height * scale) / 2;
        const psdSize = {
          scaleX,
          scaleY,
          left,
          top,
        };
        this.psdCanvas = new fabric.Canvas(`psdCanvas-${this.id}`, {
          selection: false,
          backgroundColor: "",
          width: psdData.width,
          height: psdData.height,
          hoverCursor: "default", // 鼠标悬停在对象上时的样式
          moveCursor: "move", // 移动对象时的样式
          defaultCursor: "default", // 默认样式
        });
        this.psdStyle = {
          "transform-origin": "left top",
          "margin-left": `${psdSize.left}px`,
          "margin-top": `${psdSize.top}px`,
          transform: `scale(${psdSize.scaleX}, ${psdSize.scaleY})`,
        };
        this.buildPsdValue();
        return;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },

    async drawAllLayers(value) {
      try {
        this.psdData = value;
        await this.$nextTick();
        if (!this.psdCanvas) {
          this.initPsdCavans();
        } else {
          this.psdCanvas.clear();
        }
        for (let item of this.psdData.psdDatas) {
          await this.drawCanvas(item);
        }
        this.psdCanvas.renderAll();
        const img = this.psdCanvas.toDataURL();
        this.loading = false;
        this.$emit("setEffectImg", img);
        return img;
      } catch (error) {
        console.log("🚀 ~ error:", error);
        throw error;
      }
    },
    async drawAllLayersByFactory(value) {
      try {
        this.psdCanvas.clear();
        await this.$nextTick();
        for (let item of value) {
          await this.drawCanvas(item);
        }
        this.psdCanvas.renderAll();
        const img = this.psdCanvas.toDataURL();
        return img;
      } catch (error) {
        console.log("🚀 ~ error:", error);
      }
    },

    setSrc(name, src) {
      return new Promise((resolve, reject) => {
        const oldImage = this.psdCanvas
          .getObjects()
          .find((item) => item.name === name);
        if (oldImage) {
          oldImage.setSrc(src, (imgObj) => {
            resolve(imgObj);
          });
        }
      });
    },

    //批量设计替换
    async replaceImageBatch({ psdData, names }) {
      try {
        this.psdCanvas.renderOnAddRemove = false;
        const promises = [];
        for (let name of names) {
          const layerData = psdData.psdDatas.find((item) => item.N === name);
          if (!layerData) continue;
          const value = layerData.CL
            ? layerData.CL.find((i) => i.T == "SmartObject")
            : layerData;
          promises.push(this.setSrc(name, value.IMG));
        }
        await Promise.all(promises);
        this.psdCanvas.renderOnAddRemove = true;
        await this.$nextTick();
        this.psdCanvas.renderAll();
        const img = this.psdCanvas.toDataURL();
        return img;
      } catch (error) {
        console.log("🚀 ~ error:", error);
        throw error;
      }
    },
    async replaceImage(names) {
      try {
        this.psdCanvas.renderOnAddRemove = false;
        const promises = [];
        for (let name of names) {
          const oldImage = this.psdCanvas
            .getObjects()
            .find((item) => item.name === name);
          if (oldImage) {
            promises.push(
              this.replaceImageByName(oldImage, this.imgObject[name]),
            );
          }
        }
        await Promise.all(promises);
        this.psdCanvas.renderOnAddRemove = true;
        await this.$nextTick();
        this.psdCanvas.renderAll();
        const img = this.psdCanvas.toDataURL();
        this.$emit("setEffectImg", img);
        return;
      } catch (error) {
        console.log("🚀 ~ error:", error);
        throw error;
      }
    },
    replaceImageByName(oldImage, newImageUrl) {
      return new Promise((resolve, reject) => {
        oldImage.setSrc(
          newImageUrl,
          (imgObj) => {
            resolve(imgObj);
          },
          {
            crossOrigin: "anonymous",
          },
        );
      });
    },

    loadFabricImage(url) {
      return new Promise((resolve, reject) => {
        fabric.Image.fromURL(
          url,
          (imgObj) => {
            resolve(imgObj);
          },
          {
            crossOrigin: "anonymous",
          },
        );
      });
    },

    async drawCanvas(item) {
      try {
        const canvas = this.psdCanvas;
        const layers = item.T === "Group" ? item.CL || [] : [item];
        for (const layer of layers) {
          const name = layer.T === "SmartObject" ? item.N : layer.N;
          if (layer.IMG) {
            const PATH = item.MK?.path || "";
            const { X, Y, O, WT } = layer;
            const blendMode = this.bmList[layer.BM] || "source-over";
            let imgObj = await this.loadFabricImage(
              this.imgObject[name] || layer.IMG,
            );
            imgObj.name = name;
            imgObj.set({
              selectable: false,
              left: X,
              top: Y,
              opacity: O,
              globalCompositeOperation: blendMode,
              hasControls: false,
              hasBorders: false,
            });
            if (PATH) {
              const clipPath = new fabric.Path(PATH, {
                fill: "transparent",
                objectCaching: false,
                absolutePositioned: true,
              });
              // 获取 path 的宽高
              const { left, top } = clipPath.getBoundingRect();
              clipPath.set({
                left: item.MK.left + left,
                top: item.MK.top + top,
              });
              imgObj.clipPath = clipPath;
            }
            canvas.add(imgObj);
          }
        }
      } catch (error) {
        console.error("Error processing layer:", error);
      }
    },

    // 解析SVG路径并获取边界
    parseSVGPath(pathString) {
      if (!pathString) return null;

      const commands = pathString.match(/[A-Za-z][^A-Za-z]*/g);
      if (!commands) return null;

      let minX = Infinity,
        minY = Infinity;
      let maxX = -Infinity,
        maxY = -Infinity;
      let currentX = 0,
        currentY = 0;

      for (const command of commands) {
        const type = command[0];
        const args = command
          .slice(1)
          .trim()
          .split(/[\s,]+/)
          .map(Number);

        switch (type.toUpperCase()) {
          case "M": // MoveTo
            currentX = args[0] || 0;
            currentY = args[1] || 0;
            minX = Math.min(minX, currentX);
            minY = Math.min(minY, currentY);
            maxX = Math.max(maxX, currentX);
            maxY = Math.max(maxY, currentY);
            break;
          case "L": // LineTo
            currentX = args[0] || currentX;
            currentY = args[1] || currentY;
            minX = Math.min(minX, currentX);
            minY = Math.min(minY, currentY);
            maxX = Math.max(maxX, currentX);
            maxY = Math.max(maxY, currentY);
            break;
          case "C": // Cubic Bezier
            for (let i = 0; i < args.length; i += 2) {
              const x = args[i];
              const y = args[i + 1];
              minX = Math.min(minX, x, currentX);
              minY = Math.min(minY, y, currentY);
              maxX = Math.max(maxX, x, currentX);
              maxY = Math.max(maxY, y, currentY);
            }
            currentX = args[4] || currentX;
            currentY = args[5] || currentY;
            break;
          case "Z": // ClosePath
            break;
        }
      }

      return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY,
      };
    },

    // 获取路径边界（带缓存）
    getPathBounds(pathString) {
      if (this.pathBoundsCache.has(pathString)) {
        return this.pathBoundsCache.get(pathString);
      }

      const bounds = this.parseSVGPath(pathString);
      if (bounds) {
        this.pathBoundsCache.set(pathString, bounds);
      }

      return bounds;
    },

    // 应用裁剪路径
    applyClipPath(ctx, pathString, clipMask) {
      if (!pathString) return false;

      try {
        const path = new Path2D(pathString);
        const bounds = this.getPathBounds(pathString);

        if (!bounds) return false;

        // 创建裁剪区域
        ctx.save();
        ctx.translate(clipMask.left, clipMask.top);
        ctx.scale(
          clipMask.width / bounds.width,
          clipMask.height / bounds.height,
        );
        ctx.translate(-bounds.x, -bounds.y);
        ctx.clip(path);
        ctx.restore();

        return true;
      } catch (error) {
        console.error("应用裁剪路径失败:", error);
        return false;
      }
    },
  },

  // 组件销毁时清理缓存
  beforeDestroy() {
    this.pathBoundsCache.clear();
    if (this.psdCanvas) {
      this.psdCanvas = null;
    }
  },
};
</script>
<style lang="scss" scoped>
.preview-box {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 600px;
  height: 600px;
  overflow: hidden;

  img {
    width: inherit;
    height: inherit;
  }
}

.effect-three {
  position: absolute;
  left: 100%;
  width: 580px;
  height: 580px;
}
</style>
